var exports = {
  "k": "xdbfd91f1--cf3181--container",
};

module.exports = exports;
